import { render, staticRenderFns } from "./afterSalesDetall.vue?vue&type=template&id=696628bc&scoped=true&"
import script from "./afterSalesDetall.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetall.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetall.vue?vue&type=style&index=0&id=696628bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696628bc",
  null
  
)

export default component.exports